import React, { Component } from 'react';
import Parse from 'parse';
import $ from "jquery";
import { MentionsInput, Mention } from 'react-mentions';
import defaultStyle from './defaultStyle'
import defaultMentionStyle from './defaultMentionStyle'
import './MentionTextarea.css';
import CommonPopup from './CommonPopup.jsx';
import SaveNotification from "./saveNotification.jsx";
//import { Notification } from 'react-web-notification'; 
/*const users = [
    {
      id: "isaac",
      display: "Isaac Newton",
    },
    {
      id: "sam",
      display: "Sam Victor",
    },
    {
      id: "emma",
      display: "emmanuel@nobody.com",
    },
  ];*/
 function time_ago(time) {

    switch (typeof time) {
      case 'number':
        break;
      case 'string':
        time = +new Date(time);
        break;
      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, 's', 1], // 60
      [120, '1m', '1 minute from now'], // 60*2
      [3600, 'm', 60], // 60*60, 60
      [7200, '1h', '1 hour from now'], // 60*60*2
      [86400, 'h', 3600], // 60*60*24, 60*60
      [172800, '1d', 'Tomorrow'], // 60*60*24*2
      [604800, 'd', 86400], // 60*60*24*7, 60*60*24
      [1209600, '1w', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'w', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, '1m', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'm', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, '1y', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'y', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
   
    ];
    var seconds = (+new Date() - time) / 1000,
      token = '',
      list_choice = 1;

    if (seconds == 0) {
      return ''
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      //token = 'from now';
      token = '';
      list_choice = 2;
    }
    var i = 0,
      format;
    while (format = time_formats[i++])
      if (seconds < format[0]) {
        if (typeof format[2] == 'string')
          return format[list_choice];
        else
          return Math.floor(seconds / format[2]) + '' + format[1] + '' + token;
      }
    return time;
  }
const getWeekStartAndEndDates = (offsetWeeks = 0) => {
  
  const now = new Date();
  let dayOfWeek =now.getDay(); //now.getDay(); 
  let startOfWeek=''; 
  let endOfWeek='';
 /* if(offsetWeeks===2)
  {     
      endOfWeek = new Date(now);
      startOfWeek =new Date(new Date(now) - (24*60*60*1000));      
      console.log('22'+dayOfWeek+'dayOfWeek'+endOfWeek+'endOfWeek'+startOfWeek+'startOfWeek')
  }else{ */  
  if(offsetWeeks===0)
  {
    //console.log('0000');
    endOfWeek =new Date(new Date().setHours(0, 0, 0, 0));//new Date(new Date(now) - (24*60*60*1000));  //new Date(new Date().setHours(0, 0, 0, 0));//new Date(now); 
     startOfWeek =new Date(now); //new Date(new Date(now) - (24*60*60*1000)); //new Date(now);
   }else
   {//console.log(' not 0000');
     endOfWeek =new Date(now); //new Date(new Date(now) - (24*60*60*1000));  //new Date(new Date().setHours(0, 0, 0, 0));//new Date(now); 
     startOfWeek =new Date(new Date(now) - (24*60*60*1000)); //new Date(now);
   } 
     
  //}
  //const startOfWeek = new Date(now);
 // const endOfWeek = new Date(now);

  startOfWeek.setDate(now.getDate() - dayOfWeek + (offsetWeeks * 7));
  startOfWeek.setHours(0, 0, 0, 0);

  endOfWeek.setDate(now.getDate() + (6 - dayOfWeek) + (offsetWeeks * 7));
  endOfWeek.setHours(23, 59, 59, 999);
  // endOfWeek = new Date(endOfWeek - (24*60*60*1000));
  /*if(offsetWeeks===0)
  {
   console.log('startOfWeek  0'+startOfWeek);
   console.log('endOfWeek 0'+endOfWeek);
 }else{
  console.log('startOfWeek else'+startOfWeek);
   console.log('endOfWeek else'+endOfWeek);
 }*/
  return { startOfWeek, endOfWeek };
};
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      caption:'',
      parseFile_210:'',
      parseFile_640:'',
      create_message:null,
      create_message_show:false,
      signup_message_show:null,
      photo_image_message:null,
      login_message_show:null,
      challenge_image_msg_size:false,
      mentioned:'',
      get_allusers:[],
      isRecipe:0,
      newEntries: [],
      lastChecked: null,
      thisWeekEntries: [],
      lastWeekEntries: [],
      isPopupOpenFooter: false,
      post_common_idFooter:'',
      isNotificationOpen:false,
      post_Notification_Id:'',
      post_Notification_Msg:'',
      post_Notification_Comment:'',
      followersListing: {},
      followinguserid:[],
      NotificationIgnore: false,
      NotificationTitle: '',
    };
    this.handleRegisterFrmSubmit = this.handleRegisterFrmSubmit.bind(this);
    this.handleLoginFrmSubmit = this.handleLoginFrmSubmit.bind(this);
    this.openSignupPopup = this.openSignupPopup.bind(this);
    this.openLoginPopup = this.openLoginPopup.bind(this);
    this.handlePhotoSubmit = this.handlePhotoSubmit.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.checkDiscard = this.checkDiscard.bind(this);
    this.discardData = this.discardData.bind(this);
    this.changeCaption = this.changeCaption.bind(this);
    this.checkPostModal = this.checkPostModal.bind(this);
    this.checkCancel = this.checkCancel.bind(this);   
    //this.getNotification();
    this.getNotificationClose();
    this.handleChange = this.handleChange.bind(this);
    this.getAllUsers();
    this.getfollowersListing();
    //this.showNotification = this.showNotification.bind(this);

    
         
  }
/*showNotification(title,body) { console.log('showNotification click');
    var options = {
      body: body,
      icon: 'favicon.ico',
      dir: 'ltr',
    };
   let notification = new Notification(title, options);
  }*/

getfollowersListing()
{
   //followers
     const currentUser = Parse.User.current();
    var followersquery = new Parse.Query('Activity');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.equalTo("type", "follow");
        followersquery.equalTo("toUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){ //console.log('followerresult'); console.log(followerresult);
               let resultcount=followerresult.length;
               if (followerresult.length > 0)
               {
                       let userdataresult = [];                      
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images,'toUser':user.get("toUser").id});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followersListing: userdataresult});                        
               }
            }
        })

    //followers

        //following
        var query = new Parse.Query('Activity');       
        query.include("user");
        query.include("image");
        query.include("toUser");
        query.include("thumbnail");
        query.equalTo("type", "follow");
        query.equalTo("fromUser", currentUser);
        var self = this;
        
        query.find().then(function(result){
            if(result){
               let resultcount=result.length;
               let followingdataresult1 = [];

               if (resultcount > 0)
               {
                   let userdataresult1 = [];
                   
                   for (var i = 0; i < resultcount; i++)
                   {
                     var user = result[i];
                    
                     let userimage='';
                     if(user.get("toUser").get("profilePictureSmall") && user.get("toUser").get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("toUser").get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }     
                     userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id,});
                     followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});
                     self.setState({followinguserid: followingdataresult1});                      
                    }
               }else{
                  self.setState({followinguserid: []});  
               }
            }
        })

        //following

}
  componentDidMount() { 
    // Start polling for new entries
    this.pollInterval = setInterval(this.checkForNewEntries, 5000); // Check every 10 seconds
    this.fetchThisWeekEntries();
    this.fetchLastWeekEntries();
    if (!("Notification" in window)) {
      console.log("Browser does not support desktop notification");
    } else {
      console.log("Notifications are supported");
    }
  }



  componentWillUnmount() {
   
    // Clean up the interval on component unmount
    clearInterval(this.pollInterval);
  }

   checkForNewEntries = async () => {  //console.log('checkForNewEntries');
    const user = Parse.User.current(); // Get the current logged-in user

    if (!user) {
      //console.error('User not logged in');
      return;
    }
   //query 1
    var notificationglobal = new Parse.Query('Notification');
    notificationglobal.equalTo("global", 1);
    notificationglobal.equalTo("challenge", 1);
    //notificationglobal.notEqualTo('notifiedUser', user);
    notificationglobal.notEqualTo('commentingUser', user);
    const now = new Date();
    let dateend =new Date(now);
    let datestart =new Date(new Date().setHours(0, 0, 0, 0));
    let startOfDay =new Date(new Date().setHours(0, 0, 0, 0))
    notificationglobal.include('activity');
    notificationglobal.include('activity.content');
    notificationglobal.greaterThanOrEqualTo('createdAt', datestart);
    notificationglobal.lessThanOrEqualTo('createdAt', dateend);
    notificationglobal.descending('createdAt');

    //query 1 end
   //query 2
    const query = new Parse.Query('Notification'); // Replace with your Parse class name
    query.equalTo('notifiedUser', user); // Filter by the current user

    /*if (this.state.lastChecked) {
      query.greaterThan('createdAt', this.state.lastChecked); 
    }*/
   /* const now = new Date();
    let dateend =new Date(now);
    let datestart =new Date(new Date().setHours(0, 0, 0, 0));
    let startOfDay =new Date(new Date().setHours(0, 0, 0, 0))*/
    query.include('activity');
    query.include('activity.content');
    query.greaterThanOrEqualTo('createdAt', datestart);
    query.lessThanOrEqualTo('createdAt', dateend);
    query.descending('createdAt');

    const mainQuery = Parse.Query.or(query,notificationglobal );
    mainQuery.descending('createdAt');
    try { 
     // const results = await query.find();
      const results = await mainQuery.find();
      if (results.length > 0) { //console.log(results);
        this.setState({
          newEntries: results,
          lastChecked: new Date(),
        });
      }
    } catch (error) {
      console.error('Error fetching new entries:', error);
    }
  };
  fetchThisWeekEntries = async () => {
    const { startOfWeek, endOfWeek } = getWeekStartAndEndDates(0);//0
    await this.fetchEntriesForWeek(startOfWeek, endOfWeek, 'thisWeekEntries');
  };
  
  fetchLastWeekEntries = async () => {
    const { startOfWeek, endOfWeek } = getWeekStartAndEndDates(-1);
    await this.fetchEntriesForWeek(startOfWeek, endOfWeek, 'lastWeekEntries');
  };
  fetchEntriesForWeek = async (startOfWeek, endOfWeek, stateKey) => {
    const user = Parse.User.current(); // Get the current logged-in user

    if (!user) {
      console.error('User not logged in');
      return;
    }

    //query 1
    var notificationglobal = new Parse.Query('Notification');
    notificationglobal.equalTo("global", 1);
    notificationglobal.equalTo("challenge", 1);
   // notificationglobal.notEqualTo('notifiedUser', user);
    notificationglobal.notEqualTo('commentingUser', user);
    notificationglobal.include('activity');
    notificationglobal.include('activity.content');
    notificationglobal.greaterThanOrEqualTo('createdAt', startOfWeek);
    notificationglobal.lessThanOrEqualTo('createdAt', endOfWeek);
    notificationglobal.descending('createdAt');
 

    //query 1 end
    const query = new Parse.Query('Notification'); 
    query.greaterThanOrEqualTo('createdAt', startOfWeek);
    query.lessThanOrEqualTo('createdAt', endOfWeek);
    query.include('activity');
    query.include('activity.content');
    query.equalTo('notifiedUser', user); 
    query.descending('createdAt');

     const mainQuery = Parse.Query.or(query,notificationglobal );
    mainQuery.descending('createdAt');

    try {
     // const results = await query.find();
        const results = await mainQuery.find();// console.log(results);
      this.setState({ [stateKey]: results });
    } catch (error) {
      console.error('Error fetching entries:', error);
    }
  };
   renderUserSuggestion = (suggestion, search, highlightedDisplay) => (
    <div className="user-suggestion">
      <img src={suggestion.avatar} alt={suggestion.display} className="user-avatar" />
      <div className='details'>
        <span className="displayUserName">{highlightedDisplay}</span>
        <span className="displayName">{suggestion.displayName}</span>
      </div>
    </div>
  );

 
  getAllUsers() {
    var query = new Parse.Query('_User');
        query.limit(999999999);
        query.include("profilePictureSmall");
        query.include("displayUsername");
        query.exists("displayUsername");
        query.include("name");
        var self = this;
        query.find().then(function(result){
            let userdataresult1 = [];
            
            if(result){
                for (var i = 0; i < result.length; i++)
                   {
                  var user = result[i];
                    
                     let userimage='';
                     if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }  
                    
                     userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                     self.state.get_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                 }
                     this.state.get_allusers=userdataresult1;
            }else {
                console.log("No users found");
            }
        }, function(error){
        });
       
  }
   handleChange = function(e){      
       this.setState({mentioned: e.target.value});
   }

  openLoginPopup = function(e){
    $('#close_signup').trigger('click');   
    $('#login_popup_btn').trigger('click');
   
  }
  checkPostModal = function(e){
    var forms = document.forms.new_photo_form;
    var caption=forms.caption.value;
    var dataurl_210=forms.dataurl_210.value;
    if(caption!=='' || dataurl_210!=='') {
      $('#close_Postmodalwithdiscard').attr("style", "display: block");
      $('#close_Postmodal').attr("style", "display: none");

      if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }
    }else {
      $('#close_Postmodalwithdiscard').attr("style", "display: none");
      $('#close_Postmodal').attr("style", "display: block");
      if (!$(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }
    }
    /*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }*/
  }
  changeCaption = function(e){
    var forms = document.forms.new_photo_form;
    var caption=forms.caption.value;
    var dataurl_210=forms.dataurl_210.value;
     this.setState({mentioned: e.target.value});
    if(caption!=='' || dataurl_210!=='') {
      $('#close_Postmodalwithdiscard').attr("style", "display: block");
      $('#close_Postmodal').attr("style", "display: none");
      /*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }*/
    } else {
      $('#close_Postmodalwithdiscard').attr("style", "display: none");
      $('#close_Postmodal').attr("style", "display: block");
      /*if (!$(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }*/
    }
  }
  discardData = function(e){   
   this.setState({mentioned: ''}); 
     $("#photoUrlInput").val('');
     $("#dataurl_210").val('');
     $("#dataurl_640").val('');
     $("#dataurl_640_img").val('');
     $("#dataurl_210_img").val('');
     $("#caption").val('');
     $("#profilePicturePreview").parent(".img_view").attr("style", "display: none");
     document.getElementById("profilePicturePreview").src = "/images/defaultcamera.png";
  }
  checkCancel = function(e){ 
    if (!$(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").addClass("post_modal_overlay");
      }
  }
  checkDiscard = function(e){       
    setTimeout(() => {
      this.setState({mentioned: ''});    
     $('#close_Postmodal').trigger('click');    
     $("#photoUrlInput").val('');
     $("#dataurl_210").val('');
     $("#dataurl_210_img").val('');
     $("#dataurl_640").val('');
     $("#dataurl_640_img").val('');     
     $("#caption").val('');
     $("#profilePicturePreview").parent(".img_view").attr("style", "display: none");
     document.getElementById("profilePicturePreview").src = "/images/defaultcamera.png";
    },500);       
    $('#close_Postmodalwithdiscard').attr("style", "display: none");
    $('#close_Postmodal').attr("style", "display: block");
    if (!$(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $(".modal.fade.post_modal.createPostModal").addClass("post_modal_overlay");
      }
  }
  
  openSignupPopup = function(e){
     $('#close_login').trigger('click');
     $('#register_popup_btn').trigger('click');    
  }
  handleLoginFrmSubmit(event) {
    event.preventDefault();
    var forms = document.forms.login_frm;
    var username=forms.login_email.value;
    var password=forms.login_password.value;
    var user = new Parse.User();
    var self = this;
    var userloggedin = Parse.User.logIn(username, password).then(function(user) {
      localStorage.setItem('username',user.get("username") );
      localStorage.setItem('useremail',user.get("email") );
      localStorage.setItem('sessionToken',user.get("sessionToken") );
      localStorage.setItem('isLoggedin',true );
      localStorage.setItem('ispicture_popup',false ); 
      //window.alert( 'You have successfully loggedin');                 
      window.location.href = "/";  
    }).catch(function(error){
         self.setState({login_message_show:error.message});  
       setTimeout(() => {
          self.setState({login_message_show:null}); 
        }, 8000);
    });
  }
  handleRegisterFrmSubmit(event) {
    event.preventDefault();
    var forms = document.forms.new_register;
    var email=forms.email.value;
    var password=forms.password.value;
    var user = new Parse.User();


    var getusername =  email.replace(/@.*$/,"");
    var username = getusername!==email ? getusername : null;
    //user.set("username", username);
    user.set("username", email);
    user.set("password", password);
    user.set("email", email);
    user.set("displayName", username);
    user.set("displayUsername", username);
    user.set("isCreator", 0);
    user.set("firstName", '');
    user.set("lastName", '');
    user.set("veganSince", '');
    user.set("isAdmin", '0');
    user.set("recipeRate", '$0');
    user.set("videoRate", '');
    user.set("isBusiness", 0);
    var self = this;
    
    user.signUp().then(function(user) {              
      var userloggedin = Parse.User.logIn(email, password).then(function(user) {
      localStorage.setItem('username',user.get("username") );
      localStorage.setItem('useremail',user.get("email") );
      localStorage.setItem('sessionToken',user.get("sessionToken") );
      localStorage.setItem('isLoggedin',true );
      localStorage.setItem('ispicture_popup',true );        
      window.location.href = "/"; 

      }).catch(function(error){
          console.log("Error: " + error.code + " " + error.message);
      });

    }).catch(function(error){

          self.setState({signup_message_show:error.message});  
      //window.alert( error.message);
      //$("form#new_register")[0].reset();  
           setTimeout(() => {
          self.setState({signup_message_show:null}); 
        }, 8000);
      return false;
    });
  }

  /*getNotification() {
    $('#notf_sidebar').val(0);
    let notf_sidebar=$('#notf_sidebar').val();
    if(notf_sidebar!=true) {
      $(".notf_sidebar").css({"left": "398px"});
      $('#notf_sidebar').val(1);
      $('#notf_sidebar_close').val(0);
    } else { 
      $(".notf_sidebar").css({"left": "-398px"});
      $('#notf_sidebar').val(0);
      $('#notf_sidebar_close').val(1);
    }
  } */
  getNotificationClose() {
    let notf_sidebar_close=$('#notf_sidebar_close').val('');
    let notf_sidebar=$('#notf_sidebar').val('');
    if(notf_sidebar_close==true) {
      $(".notf_sidebar").css({"left": "398px"});
      $('#notf_sidebar_close').val(0);
      $('#notf_sidebar').val(1);
    } else { 
      $(".notf_sidebar").css({"left": "-398px"});
      $('#notf_sidebar_close').val(1);
      $('#notf_sidebar').val(0);
    }
  } 
 toggleNotification = (postid,msg,comment) => {   //console.log('toggleNotification'+postid);
      var self = this;
        self.setState(prevState => ({
          isNotificationOpen: !prevState.isNotificationOpen,
          post_Notification_Id: postid,
          post_Notification_Msg: msg,
          post_Notification_Comment:comment  
        }));
        //self.setState({ post_Notification_Id: postid });        
      };

handleFileChange = (event) => {
    const file = event.target.files[0];   
    var self = this;  
    if(file)
    {

    const fileSizeInBytes = file.size; 
    const fileSizeInKB = fileSizeInBytes / 1024; 
    const maxSizeInKB = 20480; // 20MB

    if (fileSizeInKB > maxSizeInKB) {
       self.setState({create_message_show:true}); 
       self.setState({create_message:"File size exceeds the limit."});        
    } else {
     const fileType = file.type;    

    if (fileType === 'image/jpeg' || fileType === 'image/png') {
                let imageFile = event.target.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                var img = document.createElement("img");
                img.onload = function (event) {
                var custom_width_640=640;
                var custom_width_210=210;
                if(custom_width_640)
                {
                    var canvas = document.createElement("canvas");
                    const canvasResize = document.createElement('canvas');
                    const ctxResize = canvasResize.getContext('2d');                    
                    const maxWidth = 1000; 
                    const maxHeight = 1000; 
                    const aspectRatio = img.width / img.height;
                      let newHeightCheck=0;
                    let newWidthCheck=0;
                    let newMessageCheck='';

                    let newWidth = img.width;
                    let newHeight = img.height;
                    if (img.width > maxWidth) {
                        newWidth = maxWidth;
                        newHeight = newWidth / aspectRatio;
                    }
                    if (newHeight > maxHeight) {
                        newHeight = maxHeight;
                        newWidth = newHeight * aspectRatio;
                    }
                    if(custom_width_640>newHeight || custom_width_640>newWidth )
                    {
                         if(custom_width_640>newHeight)
                        {
                            newHeightCheck=newHeight;
                            newMessageCheck= "Please upload a larger size image. The height proportionally is "+parseInt(newHeight)+"px, it must be at least 640px";
                        }
                        if(custom_width_640>newWidth)
                        {
                            newWidthCheck=newWidth;
                             newMessageCheck= "Please upload a larger size image. The  width proportionally is "+parseInt(newWidth)+"px, it must be at least 640px";
                        }
                        if(custom_width_640>newHeight && custom_width_640>newWidth)
                        {
                            newMessageCheck= "Please upload a larger size image. The  width/height proportionally is "+parseInt(newWidth)+"px & "+parseInt(newHeight)+"px, it must be at least 640px";
                        }
                          self.setState({challenge_image_msg_size:newMessageCheck});  
                         //console.log('less');
                         //self.setState({photo_image_message:"Please upload large size image!"});  
                         $("#profilePicturePreview").parent(".img_view").attr("style", "display: none");
                         document.getElementById("profilePicturePreview").src = "/images/defaultcamera.png";
                         $("#photoUrlInput").val('');
                         $("#dataurl_210").val('');
                         $("#dataurl_640").val('');
                         $("#dataurl_640_img").val('');
                         $("#dataurl_210_img").val('');
                         $('#large_challenge_image_btn').trigger('click');
                    }else
                    {

                    canvasResize.width = newWidth;
                    canvasResize.height = newHeight;
                    ctxResize.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);
                    const resizedDataURL = canvasResize.toDataURL('image/jpeg');
                    const canvasCrop = document.createElement('canvas');
                    const ctxCrop = canvasCrop.getContext('2d');
                    const cropWidth = custom_width_640;
                    const cropHeight = custom_width_640;
                    canvasCrop.width = cropWidth;
                    canvasCrop.height = cropHeight;
                    const x = (newWidth - cropWidth) / 2;
                    const y = (newHeight - cropHeight) / 2;
                    ctxCrop.drawImage(canvasResize, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                    const croppedDataURL = canvasCrop.toDataURL('image/jpeg');
                    var dataurl_640 = croppedDataURL; 

                    //new
                     if(custom_width_210)
                {
                    var canvas = document.createElement("canvas");                    
                    const canvasResize = document.createElement('canvas');
                    const ctxResize = canvasResize.getContext('2d');                    
                    const maxWidth = 500; 
                    const maxHeight = 500; 
                    const aspectRatio = img.width / img.height;
                    let newWidth = img.width;
                    let newHeight = img.height;

                    if (img.width > maxWidth) {
                        newWidth = maxWidth;
                        newHeight = newWidth / aspectRatio;
                    }
                    if (newHeight > maxHeight) {
                        newHeight = maxHeight;
                        newWidth = newHeight * aspectRatio;
                    }

                   

                    canvasResize.width = newWidth;
                    canvasResize.height = newHeight;
                    ctxResize.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);

                    const resizedDataURL = canvasResize.toDataURL('image/jpeg');

                    const canvasCrop = document.createElement('canvas');
                    const ctxCrop = canvasCrop.getContext('2d');
                    const cropWidth = custom_width_210;
                    const cropHeight = custom_width_210;
                    canvasCrop.width = cropWidth;
                    canvasCrop.height = cropHeight;
                    const x = (newWidth - cropWidth) / 2;
                    const y = (newHeight - cropHeight) / 2;
                    ctxCrop.drawImage(canvasResize, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                    const croppedDataURL = canvasCrop.toDataURL('image/jpeg');
                    var dataurl_210 = croppedDataURL;
                    /*new code 1*/
                  
                }
                if(dataurl_640!==undefined || dataurl_210!==undefined)
                {
                const dataurl_210s = document.getElementById('dataurl_210');
                dataurl_210s.value = dataurl_210;
                const dataurl_640s = document.getElementById('dataurl_640');
                dataurl_640s.value = dataurl_640;
                
                const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
                const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });

                parseFile_640.save().then((savedFile) => {
                 const dataurl_640_img = document.getElementById('dataurl_640_img');
                 dataurl_640_img.value = savedFile.url();
                }).catch((error) => {
                  console.error('Error saving file:', error);
                });
                parseFile_210.save().then((savedFile) => {
                 const dataurl_210_img = document.getElementById('dataurl_210_img');
                 dataurl_210_img.value = savedFile.url();
                }).catch((error) => {
                  console.error('Error saving file:', error);
                });
                $("#profilePicturePreview").parent(".img_view").attr("style", "display: block");
                 document.getElementById("profilePicturePreview").src = dataurl_640;
              }


                    //new
                   }
                }
               
                    
            }
                    img.src = e.target.result;
                }
                reader.readAsDataURL(imageFile);
            }else {
              console.log('Unsupported file type.');
               self.setState({create_message_show:true});  
               self.setState({create_message:'Unsupported file type.'}); 
              // You can display an error message or take other actions here
            }
            $('#close_Postmodalwithdiscard').attr("style", "display: block");
            $('#close_Postmodal').attr("style", "display: none");
            /*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
               $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
            }*/
          }
          setTimeout(() => {
          self.setState({create_message_show:false});  
          self.setState({create_message:null}); 
          self.setState({photo_image_message:null});           
        }, 3000);
     }
  };


    handlePhotoSubmit(event) {
     event.preventDefault();
     var forms = document.forms.new_photo_form;
     var caption=forms.caption.value;
     var dataurl_210=forms.dataurl_210.value;
     var dataurl_640=forms.dataurl_640.value;   
     var dataurl_210_img=forms.dataurl_210_img.value;
     var dataurl_640_img=forms.dataurl_640_img.value;
     let isRecipe=this.state.isRecipe;

      var self = this;  
     if(caption==='')
         {
          self.setState({create_message_show:true}); 
          self.setState({create_message:"Please write some caption first!"});  
          
           //window.alert('Please write some caption first!');
         }else if(dataurl_210==='' || dataurl_210_img==='')
         {
          self.setState({create_message_show:true});  
          self.setState({create_message:'Please upload image.'});  
          
           //window.alert('Please upload image.');
         }else
         {
            const currentUser = Parse.User.current();
            if (currentUser) {
                let isRecipeVal=false;
                const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
                const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });
                const Photo = Parse.Object.extend('Photo');
                const photo = new Photo();
                let currentUser = Parse.User.current();             
                photo.set('image', parseFile_640);  
                photo.set('thumbnail', parseFile_210);
                photo.set('nonMealPost', 1);
                photo.set('user', currentUser);
                photo.set('caption', caption);
                photo.set('fulltext', caption); 
                photo.set('impr', 0);
                if(isRecipe===true || isRecipe===1)
                {
                    isRecipeVal=true;
                    photo.set('isRecipe', isRecipeVal);
                }

                let captionusername='';
                let captionusernameupdated='';
                if(caption)
                {
                   captionusername = caption.match(/@\w+/);
                     if (captionusername) {
                      captionusernameupdated=captionusername[0].substr(1);
                    }             
                }
                 
          
                  
                    photo.save().then((photodata) => {
 
                  if(captionusernameupdated)
                  {
                    //this.toggleNotification(photo.id,'tagged you in a post','');
                    this.toggleNotification(photo.id,'mentioned you in a post','');
                    self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});  
                  }
                      $('#close_Postmodal').trigger('click');
                   
                      setTimeout(() => {
                       $("#caption").val('');
                       window.location.href = "/";
                        },3000);
                     }).catch((error) => {
                        console.log(error.message);
                     });
            } else {
            }
         }
         setTimeout(() => {
          self.setState({create_message_show:false});  
          self.setState({create_message:null}); 
        }, 3000);
    }
handleUnFollowMyProfileLike= (e) => {
     let datapost_id=e.target.dataset.id;
     var self = this;
        const currentUser = Parse.User.current();
        $('.followimg_button #followpopup_'+datapost_id).attr("style", "pointer-events: none"); 
        if(currentUser) {
            var query = new Parse.Query('User');
            query.equalTo("objectId", datapost_id);
            query.first().then(function(result){
               if(result)
               {
                let touser=result; //console.log('touser');console.log(touser);
                var checksavequery = new Parse.Query('Activity');  
                checksavequery.equalTo('type', 'follow'); 
                checksavequery.equalTo('toUser', touser);
                checksavequery.equalTo('fromUser',currentUser);
                checksavequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } 
                              })
                              .then((deletedObject) => {
                                    setTimeout(() => {
                                      $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                                      $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                                       $('.followimg_button #followpopup_'+datapost_id).attr("style", "pointer-events: auto"); 
                                    
                                      self.getfollowersListing();
                                    },1000);
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              }); 
               }
           })
        }else
        {
            return false;
        }


    }


handleFollowMyProfileLike = (e) => {  
        let datapost_id=e.target.dataset.id;
        $('.followimg_button #followpopup_'+datapost_id).attr("style", "pointer-events: none"); 
        var self = this;
        const currentUser = Parse.User.current();
        if(currentUser) {
          var query = new Parse.Query('User');
          query.equalTo("objectId", datapost_id);
          query.first().then(function(result){
            if(result) {
              let touser=result;          
              var Activity = Parse.Object.extend("Activity");
              var activity = new Activity();
              activity.set('fromUser', currentUser);
              activity.set('toUser', touser);              
              activity.set('type', 'follow'); 
             activity.save().then((savedFile) => {
                setTimeout(() => {
                 $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                  $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                  $('.followimg_button #followpopup_'+datapost_id).attr("style", "pointer-events: auto");
                  self.toggleNotification(touser,'started following you.','');
                  self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                 // self.singlegetUsersCommentLike(datapost_id);     
                  self.getfollowersListing();      
                  
                },1000);
              }).catch((error) => {
              });              
            }
          })
        } else {
          $('#kitchenQrModal_btn').trigger('click');  
          return false;
        }
      }

  render() {

var isPopupOpenFooter= this.state.isPopupOpenFooter;
var postcommonid= this.state.post_common_idFooter;
var isNotificationOpen=this.state.isNotificationOpen; 
var post_Notification_Ids=this.state.post_Notification_Id; 
var post_Notification_Msg=this.state.post_Notification_Msg; 
var post_Notification_Comment=this.state.post_Notification_Comment;
let followersListing=this.state.followersListing;
let followinguserid=this.state.followinguserid;

let NotificationTitle=this.state.NotificationTitle;
let NotificationIgnore=this.state.NotificationIgnore;
var self = this;
    const togglePopup = (postid) => {
        this.setState(prevState => ({
          isPopupOpenFooter: !prevState.isPopupOpenFooter,
        }));
        this.setState({ post_common_idFooter: postid });
        
      };
const updateNotification = (entryid,globaldata) => {
  console.log('updateNotification globaldata globaldata')
  if(globaldata===1)
  {
     console.log(globaldata+'Loop globaldata')
     let currentUser = Parse.User.current(); 
     var userquery = new Parse.Query('User');    
        userquery.limit(999999999);  
        userquery.notEqualTo("displayUsername", currentUser.get("displayUsername"));

        userquery.find().then(function(result){
      
    
      if(result)
        {
          let countercheck=0;
        for (const matchusername of result) 
             {
                if(matchusername!=='')
                {
                  countercheck=1;
                }
             }
             if(countercheck===1)
             {
              console.log('countercheck done'+countercheck); 
              var query = new Parse.Query('Notification');
              query.equalTo("objectId", entryid);
              query.first().then(function(result){
                 if(result)
                 {
                  result.set('webviewed', 0); 
                  result.save().then((resultSaved) => {

                  })
                  }
                })
             }
           }
         })

  }else{
    var query = new Parse.Query('Notification');
    query.equalTo("objectId", entryid);
    query.first().then(function(result){
       if(result)
       {
        result.set('webviewed', 0); 
        result.save().then((resultSaved) => {

        })
        }
      })
  }

}
 const makeNotification = (title,body) => {
     console.log('make showNotification');
     var options = {
      body: body,
      icon: 'favicon.ico',
      dir: 'ltr',
    };
   let notification = new Notification("Joel's Kitchen", options);
}


    return (
      <React.Fragment>


    




        {isNotificationOpen?<SaveNotification   isOpen={isNotificationOpen}  postNotificationid={post_Notification_Ids} postMsg={post_Notification_Msg} postPhotoid={post_Notification_Ids} postActivityComment={post_Notification_Comment}  />:""}  
        {/* Login Modal */}
       <CommonPopup   isOpen={isPopupOpenFooter} onClose={(e) => {togglePopup(postcommonid);} } postcommonid={postcommonid} /> 
        <div className="modal fade auth_modal ragister_login_model createPostCloseModal" id="loginModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="loginModalTitle" aria-hidden="true">
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='action-part'>
                  <a href='javascript:void(0);' className='close cancel  btn-post-cancel'  data-dismiss="modal" aria-label="Close" title='Cancel'>
                    <img src="/images/close.svg" alt="Close"/>
                  </a>
                </div>
                <div className='inner'>
                  <div className="logo_login_main">
                    <div className="form_midddle">
                      <div className="logo">
                        <a id="logo" rel="home" href="/">
                          <img src="/images/joelskitchen_logo.png" alt="Joel's Kitchen" className='dt_logo'/>
                          {/*<span className='divider'></span>
                          <img src="/images/crt_mrk_plc.png" alt="Creator Marketplace" className='txt_logo'/>*/}
                        </a>
                      </div>
                      <form className="logiN_form" id="login_frm" onSubmit={this.handleLoginFrmSubmit}>
                        <label className='frm-error error-msg-data'>{this.state.login_message_show}</label>
                        <div className="input"><input type="text"
                          placeholder="Email"
                          size="large"
                          name="login_email"
                          className="form-control"
                          required
                        /></div>
                        <div className="input"><input
                          placeholder="Password"
                          size="large"
                          type="password"
                          name="login_password"
                          className="form-control"
                          required
                        /></div>
                        <div className="frm-lbl text-right">
                          <a href="javascript:;" className="forgot_password" >forgot password?</a>
                        </div>
                        <div className='secondary-btn btn-wrp cta_btn '>
                          <button className="submit_button_ragister action" type="submit">Log in</button>
                        </div>
                      </form>
                    </div>
                    <div className="logiN_singUp">
                      Don’t have an account? <a href="#" onClick={this.openSignupPopup}>Sign up</a>
                    </div>                  
                  </div>
                </div>
              </div>
            </div>
            {/*<div className="modal-content">
              <div className="modal-body">
                <button type="button" className='close' id="close_login"  data-dismiss="modal" aria-label="Close">
                  <img src="/images/close.svg" alt="Close"/>
                </button>
                <div className="form_grp form-part">
                  <form className="form-signup form_mn" id="login_frm" onSubmit={this.handleLoginFrmSubmit}>
                    <div className='form_logo'>
                      <img src="/images/joelskitchen_logo.png" alt="Joel's Kitchen"/>
                    </div>
                    <div className="frm_wrapper">
                      <label className='frm-error'>{this.state.login_message_show}</label>
                      <div className="frm_grp">
                        <input type="text"
                          placeholder="Email"
                          size="large"
                          name="login_email"
                          className="form-control"
                          required
                        />
                      </div>
                      <div className="frm_grp">
                        <input
                          placeholder="Password"
                          size="large"
                          type="password"
                          name="login_password"
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className="btn_action cta_btn primary-btn text-center">
                      <button className='action'>Log in</button>
                    </div>
                    <div className='frgt-lnk text-center'>
                      <a href="#">forgot password?</a>
                    </div>
                  </form>
                </div>
                <div className="form_grp link-part">
                  <p>Don't have an account? <a href="#" onClick={this.openSignupPopup}>Sign up</a></p>
                </div>
              </div>
            </div>*/}
          </div>
        </div>
        {/* Registration Modal */}
        <div className="modal fade auth_modal ragister_login_model createPostCloseModal" id="registrationModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="registrationModalTitle" aria-hidden="true">
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='action-part'>
                  <a href='javascript:void(0);' className='close cancel btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Cancel'>
                    <img src="/images/close.svg" alt="Close"/>
                  </a>
                </div>
                {/*<button type="button" className='close' id="close_signup" data-dismiss="modal" aria-label="Close">
                  <img src="/images/close.svg" alt="Close"/>
                </button>*/}
                <div className='inner'>
                  <div className="logo_login_main">
                    <div className="form_midddle">
                      <div className="logo">
                        <a id="logo" rel="home" href="/">
                          <img src="/images/joelskitchen_logo.png" alt="Joel's Kitchen" className='dt_logo'/>
                          {/*<span className='divider'></span>
                          <img src="/images/crt_mrk_plc.png" alt="Creator Marketplace" className='txt_logo'/>*/}
                        </a>
                      </div>
                      <form className="logiN_form"   id="new_register" onSubmit={this.handleRegisterFrmSubmit}>
                       <label className='frm-error error-msg-data'>{this.state.signup_message_show}</label>                      
                        <div className="input"><input type="email"
                          placeholder="Email"
                          size="large"
                          name="email"
                          className="form-control"
                          required
                        /></div>
                        <div className="input"><input
                          placeholder="Password"
                          size="large"
                          type="password"
                          name="password"
                          className="form-control"
                          required
                        /></div>
                        <a href="javascript:;" className="forgot_password" >&nbsp;</a>
                        <div className='primary-btn btn-wrp cta_btn '>
                          <button className="signUp submit_button_ragister action" type="submit">Sign up</button>
                        </div>
                      </form>
                    </div>
                    <div className="logiN_singUp">
                      Already have an account? <a href="#" onClick={this.openLoginPopup}>Log in</a>
                    </div>                  
                  </div>
                </div>
              </div>              
            </div>

            {/*<div className="modal-content">
              <div className="modal-body">
                <button type="button" className='close' id="close_signup" data-dismiss="modal" aria-label="Close">
                  <img src="/images/close.svg" alt="Close"/>
                </button>
                <div className="form_grp form-part">
                  <form className="form-signup form_mn" id="new_register" onSubmit={this.handleRegisterFrmSubmit}>
                    <div className='form_logo'>
                      <img src="/images/login_logo.png" alt="Joel's Kitchen"/>
                    </div> 
                    <div className="frm_wrapper">
                      <label className='frm-error'>{this.state.signup_message_show}</label>
                      <div className="frm_grp">
                        <input type="email"
                          placeholder="Email"
                          size="large"
                          name="email"
                          className="form-control"
                          required
                        />
                      </div>
                      <div className="frm_grp">
                        <input
                          placeholder="Password"
                          size="large"
                          type="password"
                          name="password"
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className="btn_action cta_btn primary-btn text-center">
                      <button className='action'>Sign up</button>
                    </div>
                  </form>
                </div>
                <div className="form_grp link-part">
                  <p>Already have an account? <a href="#" onClick={this.openLoginPopup}>Log in</a></p>
                </div>
              </div>              
            </div>*/}
          </div>
        </div>
        <div className="modal fade kitchenQrModal" id="kitchenQrModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="kitchenQrModalTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Get Joel's Kitchen app</h5>
                <button type="button" className='close' id="close_signup"  data-dismiss="modal" aria-label="Close">
                  <img src="/images/close.svg" alt="Close"/>
                </button>
              </div>
              <div className="modal-body">
                <p>Scan QR code to download the app</p>
                <div className='app_qr_code'>
                  <img src="/images/app_qr_code.png" alt="App QR Code"/>
                </div>
                <p>Download from app store</p>
                <div className='app-icon'>
                  <a href="https://apps.apple.com/us/app/joels-kitchen/id1151259671" title='Download on App Store'>
                    <img src="/images/app-store.png" alt="Download on App Store"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Create a Post */}
        <div className="modal fade post_modal post_modal_overlay createPostModal" id="createPostModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostModalTitle" aria-hidden="true">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <form id="new_photo_form" onSubmit={this.handlePhotoSubmit}>
              <div className="modal-content">
                <div className="top-part">
                  <button type="button" style={{display:"none"}} onClick={this.checkPostModal}   className="close" data-toggle="modal" data-target="#createPostCloseModal" id="close_Postmodalwithdiscard" aria-label="Modal">
                    <img src="/images/close.svg" alt="Close"/>
                  </button>
                  <button type="button"  className="close" data-dismiss="modal" id="close_Postmodal" aria-label="Modal"  onClick={this.discardData}>
                    <img src="/images/close.svg" alt="Close"/>
                  </button>
                  <h5 className="modal-title">Create a Post</h5>
                  <div className='cta_btn third-btn'>
                    <button  className="submit">Share</button>
                  </div>
                </div>
                <div className="modal-body"> 
                  <div className='inner'> 
                    <div className='left-part'>
                      <label htmlFor="myFile"> 
                        <p className='create_message_alert'>{this.state.create_message}{this.state.photo_image_message}</p>
                        <div className='file_upld'>
                          {/*new*/}
                          <div className='img_view' style={{display:"none"}}>
                            <img height="" width="250" id="profilePicturePreview" src="/images/defaultcamera.png" alt="photo Picture" />
                          </div>
                          {/*new*/}
                          <div className='file-input'>
                            <p>                       
                              <input type="hidden" id="photoUrlInput" name="photoUrl"/>
                              <input type="hidden" id="dataurl_210" name="dataurl_210"/>
                              <input type="hidden" id="dataurl_640" name="dataurl_640"/>
                              <input type="hidden" id="dataurl_640_img" name="dataurl_640_img"/>
                              <input type="hidden" id="dataurl_210_img" name="dataurl_210_img"/>
                              <img src="/images/file_upload.svg" alt="Joel's Kitchen"/>
                              <span>Choose a file to upload.</span>
                            </p>
                            
                          </div>
                          <div className='file-infor'>
                            <label>We recommend using high quality .jpg & .png files less than 20MB.</label> 
                          </div>
                        </div>
                        <input type="file" id="myFile"  accept=".jpg, .jpeg, .png"  name="filename"  onChange={this.handleFileChange} />
                      </label>
                    </div>
                    <div className='right-part'>
                      <div className='post-comment'>
                        <div className='post-input'>
                          {/*  <textarea id="createPosttxt" name="createPosttxt" rows="10" placeholder="Write a caption..."></textarea>*/}
                          {/* markup="@[__display__](__id__)"*/}
                          <MentionsInput  name="caption"  id="caption"   value={this.state.mentioned} placeholder="Write a caption..." onChange={this.changeCaption} style={defaultStyle} >
                          <Mention trigger="@" data={this.state.get_allusers}   markup="@__display__ "
                            displayTransform={(id, display,displayName) => `@${display}`}
                            appendSpaceOnAdd  style={defaultMentionStyle}  renderSuggestion={this.renderUserSuggestion}
                            className="mentions__mention"  placeholder="Write a caption..."/>
                          </MentionsInput>
                          {/* <textarea name="caption"  id="caption"  onChange={this.changeCaption}  rows="10" placeholder="Write a caption..."></textarea>*/}
                        </div>
                        <div className='recept_addons'>
                          <div className='inner_wrap'>
                            <div className='left'>
                              <span className="recept-icon">
                                <img src="/images/restaurant.svg" alt="Restaurant" />
                              </span>
                              <label>Recipe included?</label>
                              <span className="help-icon">
                                <img src="/images/info.svg" alt="Info" />
                              </span>
                            </div>
                            <div className='right'>
                              <label className="switch">
                               {/* <input type="checkbox" id="creator_isCreator" name="creator_isCreator" value="1" />*/}
                                  <input type="checkbox"  value="1" id="isRecipe" name="isRecipe"  defaultChecked={this.state.isRecipe}   onClick={()=>this.setState({isRecipe:!this.state.isRecipe})} />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* Create a Post Close Modal */}
        <div className="modal fade post_modal post_modal_overlay createPostCloseModal" id="createPostCloseModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='inner text-center'>
                  <div className='title-main'>
                    <h6>Are you sure you want to leave?</h6>
                    <p>If you exit, your post won’t be saved.</p>
                  </div>
                  <div className='action-part'>
                    <a href='javascript:void(0);' className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close" title='Discard'  onClick={this.checkDiscard}>Discard</a>
                    <a href='javascript:void(0);' className='btn cancel  btn-post-cancel'  onClick={this.checkCancel} data-dismiss="modal" aria-label="Close" title='Cancel'>Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Challenge Modal */}
        <div className="modal fade post_modal post_modal_overlay challengeModal createChallengeModal" id="createChallengeModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="top-part">
                <h5 className="modal-title">Challenge Details</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <img src="/images/close.svg" alt="Close"/>
                </button>
              </div>
              <div className="modal-body">
                <div className='chlng-box'>
                  <h6>Photo</h6>
                  <p>Your post's picture will show creators the type of content you want for your challenge.</p>
                </div>
                <div className='chlng-box'>
                  <h6>Title</h6>
                  <p>This is how we will list your challenge.  Keep it short and sweet.</p>
                </div>
                <div className='chlng-box'>
                  <h6>Creative Direction</h6>
                  <p>Your creative direction serves as a guide for creators and their content. The greater freedom you give, the higher the participation.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Challenge Goal Modal */}
        <div className="modal fade post_modal post_modal_overlay challengeModal challengeGoalsModal" id="challengeGoalsModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="top-part">
                <h5 className="modal-title">Challenge Goals</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <img src="/images/close.svg" alt="Close"/>
                </button>
              </div>
              <div className="modal-body">
                <div className='chlng-box'>
                  <h6>More Creators</h6>
                  <p>We'll help you connect with the most trusted creators on social media. Get started meeting creator that are a perfect fit for growing your brand and selling your products.</p>
                </div>
                <div className='chlng-box'>
                  <h6>More Content</h6>
                  <p>Get a library of high quality content for your brand. Perfect for setting up your digital marketing campaigns.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button href='javascript:void(0);' id="large_challenge_image_btn" type="button" data-toggle="modal" data-target="#large_challenge_image" style={{display:"none"}}>submit</button>
        <div className="modal fade post_modal post_modal_overlay createPostCloseModal large_challenge_image" id="large_challenge_image" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='inner text-center'>
                  <div className='title-main'>
                    <p>{/*Please upload a larger size image!*/}{this.state.challenge_image_msg_size}</p>
                  </div>
                  <div className='action-part'>
                    <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Close'>Close</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='bg_overlay'></div>
        <div className='notf_sidebar'>
          <div className='notf_inner'>
            <div className='top_part'>
              <h2>Notifications</h2>
              <a href='javascript:void(0);' onClick={this.getNotificationClose} title='Icon'>
                <img src='/images/close.svg' alt='Close' />
              </a>
              <input type="hidden" name="notf_sidebar_close" id="notf_sidebar_close" value="0" />
            </div>
            <div className='bottom_part'>
              <aside  style={{ display: "none" }} >
                <h6>New</h6>
                <ul>
                  <li>
                    <a href='javascript:void(0);' title='Follow' className='chnlg-approv'>
                      <span className='icon'>
                          <img src='/images/ntf-challenge.png' alt='Challenge' />
                      </span>
                      <span className='detail'> Your challenge is approved!<time>1m</time></span>
                    </a>
                  </li>
                  <li>
                    <a href='javascript:void(0);' title='Follow'>
                      <span className='icon'>
                          <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/4d5cb539af6bff07a4607d156c1f00e2_profilePicture.jpg' alt='Challenge' />
                      </span>
                      <span className='detail'><strong>joelskitchen</strong> started following you.<time>2m</time></span>
                    </a>
                    <div className='flw-btn'>
                      <a href='javascript:void(0);' title='Follow'>Follow</a>
                    </div>
                  </li>
                  <li>
                    <a href='javascript:void(0);' title='Follow'>
                      <span className='icon'>
                          <img src='/images/ntf-challenge.svg' alt='Challenge' />
                      </span>
                      <span className='detail'><strong>laurencatino</strong> tagged you in a post.<time>1h</time></span>
                      <span className='usr-icon'>
                          <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg' alt='User' />
                      </span>
                    </a>
                  </li>
                </ul>
              </aside>
              <aside  style={{ display: "none" }} >
                <h6>This week</h6>
                <ul>
                  <li>
                    <a href='javascript:void(0);' title='Follow'>
                      <span className='icon'>
                          <img src='/images/default_userpic0.png' alt='Challenge' />
                      </span>
                      <span className='detail'><strong>foodie</strong> commented on your post: “YUM!” <time>5h</time></span>
                      <span className='usr-icon'>
                        <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg' alt='User' />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href='javascript:void(0);' title='Follow'>
                      <span className='icon'>
                        <img src='/images/ntf-challenge.png' alt='Challenge' />
                      </span>
                      <span className='detail'>Thank you for submitting your challenge. It is currently pending review.<time>2d</time></span>
                    </a>
                  </li>
                </ul>
              </aside>
              <aside  style={{ display: "none" }}  >
                <h6>Last week</h6>
                <ul>
                  <li>
                    <a href='javascript:void(0);' title='Follow'>
                      <span className='icon'>
                          
                      </span>
                      <span className='detail'><strong>joelskitchen</strong> liked your comment: “Looks delicious” <time>4d</time></span>
                      <span className='usr-icon'>
                        <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg' alt='User' />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href='javascript:void(0);' title='Follow'>
                      <span className='icon'>
                          <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/5989ff0d488a0df33044b58facacac4f_file.bin' alt='Challenge' />
                      </span>
                      <span className='detail'><strong>laurencatino</strong> posted to your challenge. <time>6d</time></span>
                      <span className='usr-icon'>
                        <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg' alt='User' />
                      </span>
                    </a>
                  </li>
                  <li> 
                    <a href='javascript:void(0);' title='Follow'>
                      <span className='icon'>
                          <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/53165c895f57c5e34db5716f1fb3e98c_profilePicture.jpg' alt='Challenge' />
                      </span>
                      <span className='detail'><strong>benspees</strong> liked your post. <time>1w</time></span>
                      <span className='usr-icon'>
                        <img src='https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/40fcc132bb1f5c1cf70ae38ed176ca3c_profilePicture.jpg' alt='User' />
                      </span>
                    </a>
                  </li>
                </ul>
              </aside>   

              {/*new code*/}
               <aside  className="entries_section">  
          <h6>New</h6> 
        {this.state.newEntries.length > 0 ? (
          <ul>
            {this.state.newEntries.map(function (entry, i) {
             
              {  

                 let userimage='';
                 let photoimage='';
                 const currentUser = Parse.User.current();
                 let currentUser_id='_User$'+currentUser.id;
                 let commentingUser='_User$'+entry.get('commentingUser').id;//'_User$'+entry.get('notifiedUser').id;
                 let notifiedUser_id=entry.get('notifiedUser').id;
                 let challengedata=entry.get('challenge') && entry.get('challenge')===1?entry.get('challenge'):0;
                  let commentingUserid= entry.get('commentingUser').id;
                 let globaldata=entry.get('global') && entry.get('global')===1?entry.get('global'):0;
                 let commentingUseridNew=entry.get('commentingUser').id;
                 let currentUseridNew=currentUser.id;
                 let allusers= (currentUseridNew.trim() !==commentingUseridNew.trim()===false)?1:0;
                 let usercommentdata=entry.get('comment');

                

                if(usercommentdata.includes('was awarded winner of the challenge'))
                {
                   if(entry.get('notifiedUser') && entry.get('notifiedUser').get("profilePictureSmall") && entry.get('notifiedUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('notifiedUser').get("profilePictureSmall").url();
                 }else{
                     userimage="/images/default_userpic0.png";
                 }

                }else{
                  if(entry.get('commentingUser').get("profilePictureSmall") && entry.get('commentingUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('commentingUser').get("profilePictureSmall").url();
                 }
                 else{
                     userimage="/images/default_userpic0.png";
                 }

                }


                 /*if(entry.get('commentingUser').get("profilePictureSmall") && entry.get('commentingUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('commentingUser').get("profilePictureSmall").url();
                 }
                 else{
                     userimage="/images/default_userpic0.png";
                 }*/  
                  if(entry.get('photo') && entry.get('photo').get("thumbnail") && entry.get('photo').get("thumbnail").url()!==undefined)
                 {

                     photoimage=entry.get('photo').get("thumbnail").url();
                 }
                 else{
                     photoimage="/images/default_userpic0.png";
                 } 
                 
                 let commentingUsername=entry.get('commentingUser')?entry.get('commentingUser').get('displayUsername'):'';
                 let comment_msg="commented on your post: ";
                 let comment_reply_msg="replied to a comment on your post: ";
                 
                 let checkreply_msg=entry.get('reply') && entry.get('reply')===true?1:0;
                 let checkwebnotification=entry.get('webviewed') && entry.get('webviewed')===1?1:0;
                 
                 if(usercommentdata.includes('following you'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('liked your post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('created a challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('challenge just became active!'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('challenge became active!'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('You was awarded winner of the challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('was awarded winner of the challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('saved your post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('is cooking your'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('collaborated '))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('tagged you in a post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('tagged you in a comment'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('mentioned you in a post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('mentioned you in a comment'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('Your challenge is approved'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review.'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('liked your comment'))
                 {
                    let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                    comment_msg=entry.get('comment');//entry.get('comment')+' “'+contentdata+'”  ';
                 }/*else if(usercommentdata.includes('commented your post'))
                 {
                  let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                  
                  comment_msg='commented on your post: “'+contentdata+'”  ';
                 }*/else if(usercommentdata.includes('posted to your challenge'))
                 {

                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('joined a challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(checkreply_msg===1){
                    comment_msg=comment_reply_msg +" “"+entry.get('comment')+'” ';
                 }else{
                    comment_msg=comment_msg +" “"+entry.get('comment')+'” ';//comment_msg +entry.get('comment');
                 }
                 let user_imagedata='';
                 let user_userdata='';
                 let user_userdataNotification='';
                 let user_photodata='';
                 let user_followersdata='';
                 if(followersListing!=='')
                    {
                        let followinguserids=followinguserid;
                       
                        var following_match_id=[];                    
                        var rows = followersListing.length;
                        if(rows != undefined){

                            for (var i = 0; i < rows; i++)
                            {
                               var followers = followersListing[i];
                               var follow_id_ms='followpopup_'+commentingUserid;//'followpopup_'+followers.id;
                             
                                const currentUser = Parse.User.current();  
                                let   currentUserid=currentUser.id;
                                 var chek = followinguserids.find(c =>{ return c.id === commentingUserid});//'K1iL8XNQOd'  
                                 
                              
                                var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                               
                              user_followersdata= <div>   <div className="followimg_button">
                                                {currentUserid===commentingUserid?"":followingresults.id===commentingUserid?<div className="fourth-btn btn-wrp"><a  id={follow_id_ms}   data-id={commentingUserid}   href="javascript:void(0);"  title="Unfollow"   onClick={(e) => self.handleUnFollowMyProfileLike(e)} >Unfollow </a></div>: <div className="third-btn btn-wrp"><a   id={follow_id_ms}  title="Follow"   data-id={commentingUserid}       onClick={(e) => self.handleFollowMyProfileLike(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="followpost_linkpopup">Follow</a></div>} </div>
                                               </div>
                                            
                       }
                        } 
                    }



                 if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review'))
                 {
                  user_imagedata=<img  className="challenge_pending" src='/images/ntf-challenge.png' alt='Challenge' />;
                  user_userdata='';
                  user_photodata='';
                   user_userdataNotification='';
                 }else if(usercommentdata.includes('You was awarded winner of the challenge'))
                 {
                   user_imagedata=<img className="challenge_aproved" src='/images/ntf-challenge.png' alt='Challenge' id={entry.id} />;
                  user_userdata='';
                  user_photodata='';
                   user_userdataNotification='';
                 } else if(usercommentdata.includes('was awarded winner of the challenge'))
                 {
                  //user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  let userdisplayname=entry.get('notifiedUser') && entry.get('notifiedUser').get('displayUsername')?entry.get('notifiedUser').get('displayUsername'):'';
                  user_imagedata=<a href={'/user/'+userdisplayname}><img src={userimage} alt='' /></a>;
                 // user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                  user_userdata=<a href={'/user/'+userdisplayname}><strong> {userdisplayname}</strong> </a>;
                    user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                        user_userdataNotification=userdisplayname;
                 } else if(usercommentdata.includes('joined a challenge'))
                 {
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                    user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                        user_userdataNotification=commentingUsername;
                 }else if(usercommentdata.includes('posted to your challenge'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                        user_userdataNotification=commentingUsername;
                 }else if(usercommentdata.includes('challenge just became active!'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername+"'s"}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                        user_userdataNotification=commentingUsername+"'s";
                 }else if(usercommentdata.includes('challenge became active!'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername+"'s"}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                        user_userdataNotification=commentingUsername+"'s";
                 }else if(usercommentdata.includes('started following you.'))
                 {
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;

         
                  user_photodata=<div className="flw-btn"> {user_followersdata}{/* <a href="javascript:void(0);" title="Follow">Follow</a>*/}</div>;
                  user_userdataNotification=commentingUsername;
                 }else if(entry.get('comment').includes('Your challenge is approved!'))
                 {
                  user_imagedata=<a href={'/challenge/'+entry.get('photo').id}><img className="challenge_aproved" src='/images/ntf-challenge.png' alt='Challenge' id={entry.id} /></a>;
                  user_userdata='';
                  user_photodata='';
                  user_userdataNotification='';
                 }else{
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                  user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                        user_userdataNotification=commentingUsername;
                 }

  //console.log('this.state.followersListing');
             //    console.log(followersListing);
            
           // if(entry.get('photo') && entry.get('photo').id!==undefined && entry.get('photo').get("thumbnail") && entry.get('photo').get("thumbnail").url()!==undefined) {
             // console.log('loop')

  if((currentUser_id.trim() !== commentingUser.trim()) || challengedata===1  )
{
if(checkwebnotification===1)
{
  let commonmsg='';
  if(user_userdataNotification)
  {
     commonmsg =user_userdataNotification+' '+comment_msg;
  }else{
     commonmsg =comment_msg;
  }
 
  makeNotification('',commonmsg);
  updateNotification(entry.id,globaldata);
}

 //console.log('allusers'+allusers+'globaldata'+globaldata);
             return (   
               <li  key={entry.id}  style={({display: (allusers===1 && globaldata===1 ) ? 'none' : ''})}> 
                    {/*<a href='javascript:void(0);' title='' className='chnlg-approv'>*/}
                      <span className='icon'>                      
                        {/*<a href={'/user/'+commentingUsername}>*/}  {user_imagedata} {/*</a>*/}
                      </span>
                      <span className='detail'>{/*<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>*/} {user_userdata} {comment_msg} <time>{time_ago(entry.get("createdAt"))}</time></span>
                      {/*<span className='usr-icon' >*/} {/*<a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a>*/}
                       {user_photodata}
                    {/*</a>*/}
                  </li>
                   );
         }
           //   }

            }
            })}
          </ul>
        ) : (
          <small>No notification found.</small>
        )}
  </aside>  

          <aside  className="entries_section"><h6>This week</h6>
       {this.state.thisWeekEntries.length > 0 ? (
          <ul>
            {this.state.thisWeekEntries.map(function (entry, i) {
             
              { 
                 let userimage='';
                 let photoimage=''; //commentingUseridNew  currentUseridNew
                 const currentUser = Parse.User.current();
                 let currentUser_id='_User$'+currentUser.id;
                 let commentingUser='_User$'+entry.get('commentingUser').id;
                
                 let challengedata=entry.get('challenge') && entry.get('challenge')===1?entry.get('challenge'):0;
                 let notifiedUser_id=entry.get('notifiedUser').id;
                 let commentingUserid= entry.get('commentingUser').id;
                 let globaldata=entry.get('global') && entry.get('global')===1?entry.get('global'):0;
                 let commentingUseridNew=entry.get('commentingUser').id;
                 let currentUseridNew=currentUser.id;
                 let allusers= (currentUseridNew.trim() !==commentingUseridNew.trim()===false)?1:0;
                 let usercommentdata=entry.get('comment');
                 let usercommenunitydata=entry.get('communityComment');
              
                 if(usercommentdata.includes('was awarded winner of the challenge'))
                 {
                   if(entry.get('notifiedUser') && entry.get('notifiedUser').get("profilePictureSmall") && entry.get('notifiedUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('notifiedUser').get("profilePictureSmall").url();
                 }else{
                     userimage="/images/default_userpic0.png";
                 }

                 }else{
                  if(entry.get('commentingUser').get("profilePictureSmall") && entry.get('commentingUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('commentingUser').get("profilePictureSmall").url();
                 }
                 else{
                     userimage="/images/default_userpic0.png";
                 }

                }
                  if(entry.get('photo') && entry.get('photo').get("thumbnail") && entry.get('photo').get("thumbnail").url()!==undefined)
                 {
                     photoimage=entry.get('photo').get("thumbnail").url();
                 }
                 else{
                     photoimage="/images/default_userpic0.png";
                 } 
                
                 let commentingUsername=entry.get('commentingUser')?entry.get('commentingUser').get('displayUsername'):'';
                 let comment_msg="commented on your post: ";
                 let comment_reply_msg="replied to a comment on your post: ";                 
                 let checkreply_msg=entry.get('reply') && entry.get('reply')===true?1:0;
                 if(usercommentdata.includes('following you'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('liked your post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('created a challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('challenge just became active!'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('challenge became active!'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('You was awarded winner of the challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('was awarded winner of the challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('saved your post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('is cooking your'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('collaborated '))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('tagged you in a post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('tagged you in a comment'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('mentioned you in a post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('mentioned you in a comment'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('Your challenge is approved'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('joined a challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review.'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('liked your comment'))
                 {
                     //comment_msg=entry.get('comment')+': “'+entry.get('photo').get('caption')+'”  ';
                   let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                    comment_msg=entry.get('comment');//entry.get('comment')+' “'+contentdata+'”  ';
                 }/*else if(usercommentdata.includes('commented your post'))
                 {
                 
                  let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                 
                  comment_msg='commented on your post: “'+contentdata+'”  ';
                 }*/else if(usercommentdata.includes('posted to your challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(checkreply_msg===1){
                    comment_msg=comment_reply_msg +" “"+entry.get('comment')+'” ';
                 }else{
                    comment_msg=comment_msg +" “"+entry.get('comment')+'” ';//comment_msg +entry.get('comment'); ;
                 }
                 let user_imagedata='';
                 let user_userdata='';
                 let user_photodata='';
                  let user_followersdata='';
                 if(followersListing!=='')
                    {
                        let followinguserids=followinguserid;
                       
                        var following_match_id=[];                    
                        var rows = followersListing.length;
                        if(rows != undefined){

                            for (var i = 0; i < rows; i++)
                            {
                               var followers = followersListing[i];
                               var follow_id_ms='followpopup_'+commentingUserid;//'followpopup_'+followers.id;
                             
                                const currentUser = Parse.User.current();  
                                let   currentUserid=currentUser.id;
                                 var chek = followinguserids.find(c =>{ return c.id === commentingUserid});//'K1iL8XNQOd'  
                                 
                              
                                var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                               
                              user_followersdata= <div>   <div className="followimg_button">
                                                {currentUserid===commentingUserid?"":followingresults.id===commentingUserid?<div className="fourth-btn btn-wrp"><a  id={follow_id_ms} title="Unfollow"  data-id={commentingUserid}   href="javascript:void(0);"   onClick={(e) => self.handleUnFollowMyProfileLike(e)} >Unfollow </a></div>: <div className="third-btn btn-wrp"><a   id={follow_id_ms}   title="Follow"     data-id={commentingUserid}       onClick={(e) => self.handleFollowMyProfileLike(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="followpost_linkpopup">Follow</a></div>} </div>
                                               </div>
                                            
                       }
                        } 
                    }

                 if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review'))
                 {
                  user_imagedata=<img  className="challenge_pending" src='/images/ntf-challenge.png' alt='Challenge' />;
                  user_userdata='';
                  user_photodata='';
                 }else if(usercommentdata.includes('posted to your challenge'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                       // user_userdataNotification=commentingUsername;
                 }else if(usercommentdata.includes('challenge became active!'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername+"'s"}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                       // user_userdataNotification=commentingUsername;
                 }else if(usercommentdata.includes('challenge just became active!'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername+"'s"}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                       // user_userdataNotification=commentingUsername;
                 }else if(usercommentdata.includes('You was awarded winner of the challenge'))
                 {
                   user_imagedata=<img className="challenge_aproved" src='/images/ntf-challenge.png' alt='Challenge' id={entry.id} />;
                  user_userdata='';
                  user_photodata='';
                 } else if(usercommentdata.includes('was awarded winner of the challenge'))
                 {
                  //user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                    let userdisplayname=entry.get('notifiedUser') && entry.get('notifiedUser').get('displayUsername')?entry.get('notifiedUser').get('displayUsername'):'';
                  user_imagedata=<a href={'/user/'+userdisplayname}><img src={userimage} alt='' /></a>;
                 // user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                  user_userdata=<a href={'/user/'+userdisplayname}><strong> {userdisplayname}</strong> </a>;
                    user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                 } else if(usercommentdata.includes('joined a challenge'))
                 {
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                    user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                 }else if(usercommentdata.includes('started following you.'))
                 {
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;

         
                  user_photodata=<div className="flw-btn"> {user_followersdata}{/* <a href="javascript:void(0);" title="Follow">Follow</a>*/}</div>;
                 }else if(entry.get('comment').includes('Your challenge is approved!'))
                 {
                  user_imagedata=<a href={'/challenge/'+entry.get('photo').id}><img className="challenge_aproved" src='/images/ntf-challenge.png' alt='Challenge' id={entry.id} /></a>;
                  user_userdata='';
                  user_photodata='';
                 }else{
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                  user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                 }
            
  if((currentUser_id.trim() !== commentingUser.trim()) || challengedata===1  )
         {

             return (   
               <li  key={entry.id}   style={({display: (allusers===1 && globaldata===1 ) ? 'none' : ''})}> 
                    {/*<a href='javascript:void(0);' title='' className='chnlg-approv'>*/}
                      <span className='icon'>
                        {/*<a href={'/user/'+commentingUsername}>*/}  {/*<img src={userimage} alt='' />*/} {user_imagedata} {/*</a>*/}
                      </span>
                      <span className='detail'>{/*<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>*/} {user_userdata} {comment_msg} <time>{time_ago(entry.get("createdAt"))}</time></span>
                      {/*<span className='usr-icon' >*/} {/*<a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a>*/}
                       {user_photodata}
                    {/*</a>*/}
                  </li>
                   );
           }
                    }
            })}
          </ul>
        ) : (
          <small>No notification found.</small>
        )}

       </aside>
 <aside className="entries_section">
        <h6>Last week</h6>  
         {this.state.lastWeekEntries.length > 0 ? (
          
          <ul>
            {this.state.lastWeekEntries.map(function (entry, i) {
             
              { 
                 let userimage='';
                 let photoimage='';
                 const currentUser = Parse.User.current();
                 let currentUser_id='_User$'+currentUser.id;
                 let commentingUser='_User$'+entry.get('commentingUser').id;
                 let challengedata=entry.get('challenge') && entry.get('challenge')===1?entry.get('challenge'):0;
                 let globaldata=entry.get('global') && entry.get('global')===1?entry.get('global'):0;
                 let commentingUseridNew=entry.get('commentingUser').id;
                 let currentUseridNew=currentUser.id;
                 let allusers= (currentUseridNew.trim() !==commentingUseridNew.trim()===false)?1:0;
                 let notifiedUser_id=entry.get('notifiedUser').id;
                  let commentingUserid= entry.get('commentingUser').id;
                   let usercommentdata=entry.get('comment');
                 if(usercommentdata.includes('was awarded winner of the challenge'))
                {
                   if(entry.get('notifiedUser') && entry.get('notifiedUser').get("profilePictureSmall") && entry.get('notifiedUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('notifiedUser').get("profilePictureSmall").url();
                 }else{
                     userimage="/images/default_userpic0.png";
                 }

                }else{
                  if(entry.get('commentingUser').get("profilePictureSmall") && entry.get('commentingUser').get("profilePictureSmall").url()!==undefined)
                 {
                     userimage=entry.get('commentingUser').get("profilePictureSmall").url();
                 }
                 else{
                     userimage="/images/default_userpic0.png";
                 }

                } 
                  if(entry.get('photo') && entry.get('photo').get("thumbnail") && entry.get('photo').get("thumbnail").url()!==undefined)
                 {
                     photoimage=entry.get('photo').get("thumbnail").url();
                 }
                 else{
                     photoimage="/images/default_userpic0.png";
                 } 
                
                 let commentingUsername=entry.get('commentingUser')?entry.get('commentingUser').get('displayUsername'):'';
                 let comment_msg="commented on your post: ";
                 let comment_reply_msg="replied to a comment on your post: ";                 
                 let checkreply_msg=entry.get('reply') && entry.get('reply')===true?1:0;
                 if(usercommentdata.includes('following you'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('liked your post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('created a challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('challenge just became active!'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('challenge became active!'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('You was awarded winner of the challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('was awarded winner of the challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('saved your post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('is cooking your'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('collaborated '))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('tagged you in a post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('tagged you in a comment'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('mentioned you in a post'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('mentioned you in a comment'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review.'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('Your challenge is approved'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('joined a challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(usercommentdata.includes('liked your comment'))
                 {
                    //comment_msg=entry.get('comment')+': “'+entry.get('photo').get('caption')+'”  ';
                    let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                    comment_msg=entry.get('comment');//entry.get('comment')+': “'+contentdata+'”  ';
                 }/*else if(usercommentdata.includes('commented your post'))
                 {
                    
                   let contentdata=entry.get('activity')!==undefined && entry.get('activity')?entry.get('activity').get('content'):'';
                   
                   comment_msg='commented on your post: “'+contentdata+'”  ';
                 }*/else if(usercommentdata.includes('posted to your challenge'))
                 {
                    comment_msg=entry.get('comment');
                 }else if(checkreply_msg===1){
                    comment_msg=comment_reply_msg +" “"+entry.get('comment')+'” ';
                 }else{
                    comment_msg=comment_msg +" “"+entry.get('comment')+'” ';
                 }
                 let user_imagedata='';
                 let user_userdata='';
                 let user_photodata='';
                 let user_followersdata='';
                 if(followersListing!=='')
                    {
                        let followinguserids=followinguserid;
                       
                        var following_match_id=[];                    
                        var rows = followersListing.length;
                        if(rows != undefined){

                            for (var i = 0; i < rows; i++)
                            {
                               var followers = followersListing[i];
                               var follow_id_ms='followpopup_'+commentingUserid;//'followpopup_'+followers.id;
                             
                                const currentUser = Parse.User.current();  
                                let   currentUserid=currentUser.id;
                                 var chek = followinguserids.find(c =>{ return c.id === commentingUserid});//'K1iL8XNQOd'  
                                 
                              
                                var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                               
                              user_followersdata= <div>   <div className="followimg_button">
                                                {currentUserid===commentingUserid?"":followingresults.id===commentingUserid?<div className="fourth-btn btn-wrp"><a  id={follow_id_ms}  title="Unfollow"    data-id={commentingUserid}   href="javascript:void(0);"   onClick={(e) => self.handleUnFollowMyProfileLike(e)} >Unfollow </a></div>: <div className="third-btn btn-wrp"><a   id={follow_id_ms}   title="Follow"    data-id={commentingUserid}       onClick={(e) => self.handleFollowMyProfileLike(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="followpost_linkpopup">Follow</a></div>} </div>
                                               </div>
                                            
                       }
                        } 
                    }

                 if(usercommentdata.includes('Thank you for submitting your challenge. It is currently pending review'))
                 {
                  user_imagedata=<img  className="challenge_pending" src='/images/ntf-challenge.png' alt='Challenge' />;
                  user_userdata='';
                  user_photodata='';
                 }else if(usercommentdata.includes('You was awarded winner of the challenge'))
                 {
                   user_imagedata=<img className="challenge_aproved" src='/images/ntf-challenge.png' alt='Challenge' id={entry.id} />;
                  user_userdata='';
                  user_photodata='';
                 }else if(usercommentdata.includes('was awarded winner of the challenge'))
                 {
                  //user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  let userdisplayname=entry.get('notifiedUser') && entry.get('notifiedUser').get('displayUsername')?entry.get('notifiedUser').get('displayUsername'):'';
                  user_imagedata=<a href={'/user/'+userdisplayname}><img src={userimage} alt='' /></a>;
                 // user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                  user_userdata=<a href={'/user/'+userdisplayname}><strong> {userdisplayname}</strong> </a>;
                    user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                 }else if(usercommentdata.includes('posted to your challenge'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                       // user_userdataNotification=commentingUsername;
                 }else if(usercommentdata.includes('challenge just became active!'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername+"'s"}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                       // user_userdataNotification=commentingUsername;
                 }else if(usercommentdata.includes('challenge became active!'))
                 {
                
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername+"'s"}</strong> </a>;
                   user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                       // user_userdataNotification=commentingUsername;
                 } else if(usercommentdata.includes('joined a challenge'))
                 {
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                    user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                 }else if(usercommentdata.includes('started following you.'))
                 {
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;

         
                  user_photodata=<div className="flw-btn"> {user_followersdata}{/* <a href="javascript:void(0);" title="Follow">Follow</a>*/}</div>;
                 }else if(entry.get('comment').includes('Your challenge is approved!'))
                 {
                  user_imagedata=<a href={'/challenge/'+entry.get('photo').id}><img className="challenge_aproved" src='/images/ntf-challenge.png' alt='Challenge' id={entry.id} /></a>;
                  user_userdata='';
                  user_photodata='';
                 }else{
                  user_imagedata=<a href={'/user/'+commentingUsername}><img src={userimage} alt='' /></a>;
                  user_userdata=<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>;
                  user_photodata= <span className='usr-icon' ><a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a></span>;
                 }
            
           // if(entry.get('photo') && entry.get('photo').id!==undefined && entry.get('photo').get("thumbnail") && entry.get('photo').get("thumbnail").url()!==undefined) {
  if((currentUser_id.trim() !== commentingUser.trim()) || challengedata===1  )

         {
             return (   
               <li  key={entry.id}  style={({display: (allusers===1 && globaldata===1 ) ? 'none' : ''})}> 
                    {/*<a href='javascript:void(0);' title='' className='chnlg-approv'>*/}
                      <span className='icon'>
                          {/*<img src={userimage} alt='' />*/} {user_imagedata}
                      </span>
                      <span className='detail'>{/*<a href={'/user/'+commentingUsername}><strong> {commentingUsername}</strong> </a>*/} {user_userdata} {comment_msg} <time>{time_ago(entry.get("createdAt"))}</time></span>
                      {/*<span className='usr-icon' >*/} {/*<a  href='javascript:void(0);' onClick={(e) => {togglePopup(entry.get('photo').id);}}>
                        <img src={photoimage} alt='' /> </a>*/}
                       {user_photodata}
                    {/*</a>*/}
                  </li>
                   );
          }
                    }
            })}
          </ul> 
        ) : (
         <small>No notification found.</small>
        )}
 </aside>
        
        {/*new code*/} 
            </div>
          </div>
        </div>
        <input type="hidden" name="notf_sidebar" id="notf_sidebar" value="0" />
       {/* <input type="text" name="gridtabs" id="gridtabs" value="" />*/}
{/* <input type="hidden" id="gridtabs" name="gridtabs1" value={this.state.streamtabValue1} />
 <input type="hidden" id="streampagepath" name="streampagepath1" value={this.state.streampagepath1} />*/}
        
      </React.Fragment>
    );
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/footer.jsx